import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35e3861c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "slider" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { ref } from 'vue'


export default {
  __name: 'ToggleComponent',
  props: {
  modelValue: {
    type: Boolean
  },
  radius: {
    type: Number,
    required: false,
    default: 20
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props;






const value = ref(false)

function toggle () {
  value.value = !value.value
  emits('update:modelValue', value.value)
}

if (props.modelValue) toggle()

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["toggle", value.value ? 'checked' : '']),
    onClick: toggle,
    style: _normalizeStyle(`
         --width: ${2 * __props.radius + 8}px;
         --height: ${8 + parseFloat(__props.radius)}px;
         --slider-radius: ${__props.radius}px;`)
  }, _hoisted_2, 6))
}
}

}